export default "__VITE_ASSET__DFJtDBmf__"